<template>
  <div class="partial-footer">
    <div class="space-30"></div>
    <div class="text-center padding-lateral-30">
      <div class="font-25">Gerencie seus cadastros de forma simples e segura!</div>
    </div>
    <div class="space-30"></div>
    <div class="bg-orange-color"><div class="space-10"></div></div>
    <div class="space-50"></div>
    <div class="container">
      <div class="row font-16 text-center-xs text-center-sm">
        <div class="col-md-3">
          <div class="bold font-18">Loca.Shop</div>
          <div><router-link :to="{ name: 'use_terms' }">Termos de Uso</router-link></div>
          <div><router-link :to="{ name: 'privacy_policy' }">Políticas de privacidade</router-link></div>
          <div class="space-30 hidden-md hidden-lg"></div>
          <!--
          <div><router-link :to="{ name: 'use_terms' }">Como funciona</router-link></div>
          <div><router-link :to="{ name: 'use_terms' }">Fale conosco</router-link></div>
          <div><router-link :to="{ name: 'use_terms' }">Quem somos</router-link></div>
          -->
        </div>
        <div class="col-md-3">
          <div class="bold font-18">Locatários</div>
          <div><router-link :to="{ name: 'login' }">Cadastro/Login</router-link></div>
          <div><router-link :to="{ name: 'my_rents' }">Minhas locações</router-link></div>
          <div class="space-30 hidden-md hidden-lg"></div>
          <!--
          <div><router-link :to="{ name: 'use_terms' }">Minha conta</router-link></div>
          <div><router-link :to="{ name: 'use_terms' }">FAQ</router-link></div>
          -->
        </div>
        <div class="col-md-3">
          <div class="bold font-18">Locadoras</div>
          <!-- <div><router-link :to="{ name: 'company_landing_page' }">Faça parte da nossa rede</router-link></div> -->
          <div><a :href="config.adminURL" target="_blank">Painel de gestão</a></div>
          <div class="space-30 hidden-md hidden-lg"></div>
          <!--
          <div><router-link :to="{ name: 'use_terms' }">FAQ</router-link></div>
          <a href="#"><img :src="imageUrl('mail-icon-facebook.png')" alt="Facebook Loca.Shop"></a>&nbsp;
          <a href="#"><img :src="imageUrl('mail-icon-instagram.png')" alt="Facebook Loca.Shop"></a>&nbsp;
          <a href="#"><img :src="imageUrl('mail-icon-linkedin.png')" alt="Facebook Loca.Shop"></a>&nbsp;
          <a href="#"><img :src="imageUrl('mail-icon-twitter.png')" alt="Facebook Loca.Shop"></a>&nbsp;
          <a href="#"><img :src="imageUrl('mail-icon-youtube.png')" alt="Facebook Loca.Shop"></a>
          -->
        </div>
        <div class="col-md-3">
          <div class="text-center">
            <router-link :to="{name: 'home'}">
              <img :src="imageUrl('locashop-symbol.png')" alt="Loca.Shop - Aluguel online de produtos" class="img-responsive-center">
            </router-link>
          </div>
        </div>
      </div>
      <div class="space-40"></div>
      <div class="row">
        <div class="col-xs-12 text-center">
          <div class="space-40"></div>
          <div class="font-14">CNPJ: 33.596.756/0001-02 | © 2019 - Todos os direitos reservados</div>
          <div class="space-40"></div>
        </div>
      </div>
    </div>
    <!--
    <div class="hidden-md hidden-lg mobile-bar">
      <a href="https://api.whatsapp.com/send?phone=5531998038196&text=Olá, gostaria de saber mais sobre a Loca.Shop." target="_blank" class="btn btn-sm btn-link bold font-20">
        <i class="fa fa-whatsapp"></i> (31) 99803-8196
      </a>
      <router-link v-if="routeName != 'company_registration'" :to="{name: 'company_registration'}" class="btn btn-sm btn-success bold shake">EXPERIMENTE GRÁTIS</router-link>
    </div>
    -->
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import * as config from '../../config.js'

  export default{
    name: 'PartialFooter',
    components: {},
    data () {
      return {
        config: config,
        routeName: this.$route.name
      }
    },
    computed: {
      ...mapState({
        user: state => state.user
      })
    },
    methods: {
      ...mapActions([])
    }
  }
</script>


// WEBPACK FOOTER //
// PartialFooter.vue?e80d71d0